import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomerService } from '../../core/services/customer.service';
import { environment } from '../../../environments/environment';
import { JubooResultComponent } from 'juboo-result';
import { CommonModule } from '@angular/common';

interface AdditionalInfo {
  label: string;
  show: boolean;
}

@Component({
  selector: 'app-request-detail',
  standalone: true,
  imports: [
    RouterModule,
    ReactiveFormsModule,
    JubooResultComponent,
    CommonModule
  ],
  templateUrl: './request-detail.component.html',
  styleUrl: './request-detail.component.css',
  encapsulation: ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RequestDetailComponent {
  customerService = inject(CustomerService);
  baseUrl = environment.apiUrl;

  constructor() {
  }
}
